import React from 'react';
import SettingsLayout from './SettingsLayout';

const PrivacyPolicyPage = () => {
  return (
    <SettingsLayout
      title="Privacy Policy"
      subtitle="Last updated: January 2025"
    >
      <div className="bg-white rounded-3xl border border-gray-100 p-6 space-y-6 text-sm text-gray-700 leading-relaxed">
        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            1. Introduction
          </h2>
          <p>
            Skytone ("we", "our", "us") is committed to protecting your privacy. This
            policy explains what personal information we collect, how we use it, and
            your rights under South African law — including the Protection of Personal
            Information Act (POPIA).
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            2. Information we collect
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Account information — your name, email, phone number.</li>
            <li>Location data — only when you explicitly enable it, used to show nearby pros.</li>
            <li>Booking & order history — services booked, products purchased.</li>
            <li>Payment references — we do not store your card details.</li>
            <li>Device & usage data — for security and improving the service.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            3. How we use your information
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>To connect you with beauty professionals and products.</li>
            <li>To process bookings, orders, and payments.</li>
            <li>To send you notifications about your activity.</li>
            <li>To detect fraud and keep your account secure.</li>
            <li>To improve Skytone based on aggregated usage patterns.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            4. Who we share with
          </h2>
          <p>
            We share only what's necessary with:
          </p>
          <ul className="list-disc pl-5 space-y-1 mt-1">
            <li>Professionals you book — your first name, contact, and appointment details.</li>
            <li>Paystack — to process payments securely.</li>
            <li>Firebase (Google) — for secure storage and authentication.</li>
          </ul>
          <p className="mt-2">
            We never sell your personal information to third parties.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            5. Your rights under POPIA
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Access — request a copy of your personal information.</li>
            <li>Correction — ask us to fix inaccurate data.</li>
            <li>Deletion — request deletion of your account and data.</li>
            <li>Objection — object to specific uses of your data.</li>
          </ul>
          <p className="mt-2">
            To exercise any of these, email{' '}
            <a href="mailto:support@skytone.app" className="font-bold text-[#EFA9B6] underline">
              support@skytone.app
            </a>.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            6. Data retention
          </h2>
          <p>
            We keep your account data for as long as you have an active account. If
            you delete your account, we remove your personal information within 30 days,
            except where we're required to keep it by law.
          </p>
        </section>

        <section>
          <h2 className="font-serif font-bold text-gray-900 text-base mb-2">
            7. Contact
          </h2>
          <p>
            Questions? Email us at{' '}
            <a href="mailto:support@skytone.app" className="font-bold text-[#EFA9B6] underline">
              support@skytone.app
            </a>.
          </p>
        </section>
      </div>
    </SettingsLayout>
  );
};

export default PrivacyPolicyPage;